import React from 'react';
export function PhoneFrame({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen bg-black/90 flex items-center justify-center sm:py-8" data-id="element-130">
      <div className="w-full h-screen sm:h-[850px] max-w-[430px] bg-black sm:rounded-[40px] sm:border-[8px] border-surface2 overflow-hidden relative shadow-2xl" data-id="element-131">
        {children}
      </div>
    </div>;
}